import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { FaIconLibrary, FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import {
  faCircleInfo,
  faIdBadge,
  faLayerGroup as fadLayerGroup,
  faHandshake,
  faThLarge,
  faUserLock,
  faUsers,
} from "@fortawesome/pro-duotone-svg-icons";

import {
  faAngleDown,
  faAngleRight,
  faArrowCircleLeft,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronUp,
  faCircle,
  faClipboardListCheck,
  faCopy,
  faEllipsisV,
  faExclamation,
  faExclamationTriangle,
  faFilter,
  faInfoCircle,
  faKey,
  faMinus,
  faPencil,
  faPlus,
  faPlusCircle,
  faQuestionCircle,
  faSearch,
  faTimes,
  faTrashAlt,
  faUser,
  faUserPlus,
} from "@fortawesome/pro-regular-svg-icons";

import {
  faCircle as fasCircle,
  faGripDotsVertical as fasGripDotsVertical,
  faLayerGroup,
} from "@fortawesome/pro-solid-svg-icons";

import { faTimes as falTimes } from "@fortawesome/pro-light-svg-icons";

const appIcons: any[] = [
  faAngleDown,
  faAngleRight,
  faArrowCircleLeft,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronUp,
  faCircle,
  fasCircle,
  faCircleInfo,
  faClipboardListCheck,
  faCopy,
  faEllipsisV,
  faExclamation,
  faExclamationTriangle,
  faFilter,
  fasGripDotsVertical,
  faHandshake,
  faIdBadge,
  faInfoCircle,
  faKey,
  fadLayerGroup,
  faLayerGroup,
  faMinus,
  faPencil,
  faPlus,
  faPlusCircle,
  faQuestionCircle,
  faSearch,
  faThLarge,
  faTimes,
  falTimes,
  faTrashAlt,
  faUser,
  faUserLock,
  faUserPlus,
  faUsers,
];

@NgModule({
  declarations: [],
  imports: [CommonModule, FontAwesomeModule],
  exports: [FontAwesomeModule],
  providers: [],
  bootstrap: [],
})
export class AppIconsModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(...appIcons);
  }
}
